import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default () => ({
  path: "session-revoke",
  component: withAsyncRouteLoading(() =>
    Promise.all([import("./components")]).then(
      ([importedModule0]) => importedModule0.default
    )
  ),
  childRoutes: [],
});
